<template>
    <div>
        <div class="py-[44px] md:py-[120px]">
            <!--            desktop view-->
            <div class="hidden md:grid grid-cols-10 gap-8 items-center">
                <div class="col-span-5">
                    <img
                        :src="aboutOurWorkImageSrc"
                        alt=""
                        class="w-full hover:opacity-90 transition-opacity rounded-lg"
                    />
                </div>
                <div class="col-span-5">
                    <p
                        class=" text-black font-outfit text-[28px] font-[700]">
                        About Our Work
                    </p>
                    <div v-html="aboutOurWorkMessage" class="text-black mt-[20px] text-[18px] font-outfit font-[400]"/>
                </div>
            </div>

            <!--            mobile view-->
            <div class="md:hidden flex flex-col gap-4">
                    <p
                        class=" text-black font-outfit text-[28px] font-[700]">
                        About Our Work
                    </p>
                     <img
                        :src="aboutOurWorkImageSrc"
                        alt=""
                        class="w-full hover:opacity-90 transition-opacity rounded-lg"
                    />
                    <div v-html="aboutOurWorkMessage" class="text-black mt-[20px] text-[18px] font-outfit font-[400]"/>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    components: {},
    props: {
        aboutOurWorkImageSrc: {
            type: String,
            default: null
        },
        aboutOurWorkMessage: {
            type: String,
            default: 'Our work centers around two primary programs: core platform and customized regional hubs. We connect educators to resources, and we collaborate with localized stakeholders to integrate our platform to their needs.\n'
        }
    }
};
</script>

<style scoped>

</style>
